import styles from "@/components/login-panel.module.css";
import globals from "@/globals";
import * as signals from "@/signals";
import { encodeData } from "@/utils";
import clsx from "clsx";
import { t } from "i18next";
import { JSX, useState } from "react";

function LoginPanel(): JSX.Element {
	const [isLoginFormShown, setIsLoginFormShown] = useState(false);

	const handleLoginClick = (): void => {
		setIsLoginFormShown(true);
	};

	return (
		<div className={styles["login"]}>
			{isLoginFormShown ? (
				<iframe
					src={
						"https://account.retiehe.com/login?" +
						encodeData({
							appname: globals.APP_NAME,
							page: "login",
							region: signals.dynamicInfo.value.region,
							test:
								process.env.NODE_ENV === "development"
									? "1"
									: undefined,
							theme: globals.isLight ? "light" : "dark",
						})
					}
					title={t("login")}
				></iframe>
			) : (
				<>
					<div className={clsx("app-icon", styles["app-icon"])}></div>
					<div className={styles["title"]}>
						{t("logInToGetStarted")}
					</div>
					<button
						className={clsx(
							"default-button",
							styles["login-button"],
						)}
						onClick={handleLoginClick}
						type="button"
					>
						{t("login")}
					</button>
				</>
			)}
		</div>
	);
}

export default LoginPanel;
